import SideBarUserContainer from "components/LEGACY/SidebarUser"
import getpackedLogo from "images/getpacked_Logo_weiss.svg"
import Image from "next/image"
import { ReactNode } from "react"

interface SidebarProps {
  children: ReactNode
}
const Sidebar = ({ children }: SidebarProps) => {
  return (
    <>
      <style jsx>{`
        .navList {
          list-style: none;
          padding: 0;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          margin: 0;
        }
        .sidebar {
          overflow: hidden;
          position: fixed;
          z-index: 2;
          top: 0;
          bottom: 0;
          left: 0;
          width: var(--sidebar-width);
          transition: width var(--sidebar-transition);
          background: var(--dark);
          display: flex;
          flex-direction: column;
          gap: 10px;
          padding-top: 10px;
          align-items: center;
          box-shadow: 0px 0px 13px 0px #000000;
        }
        // Hacky way to get SideBarUserContainer to end
        .sidebar > :global(> :last-child) {
          margin-top: auto;
        }
      `}</style>
      <nav className="sidebar" id="admin-sidebar">
        <Image src={getpackedLogo} layout="fixed" alt="getpacked logo" objectPosition="50% 50%" />

        <ul className="navList">{children}</ul>
        <SideBarUserContainer />
      </nav>
    </>
  )
}

export default Sidebar
